"use client";

import axios from "axios";
import { auth } from "./config";

const api = axios.create({
  baseURL: "/api",
});

let interceptorRegistered = false;

export function createFirebaseAuthAxios() {
  if (!interceptorRegistered) {
    api.interceptors.request.use(async (config) => {
      if (!auth) return config;

      const user = auth.currentUser;
      if (!user) return config;

      const token = await user.getIdToken();
      config.headers = config.headers ?? {};
      (config.headers as any).Authorization = `Bearer ${token}`;
      return config;
    });

    interceptorRegistered = true;
  }

  return api;
}
